import React from 'react';
import './ResponsibleGamingPage.css';
import { useResponsiveQueries } from '../../utils/constants';
import { motion } from 'framer-motion'
import { fadeIn } from '../../variants';

const reminderList = [
  {
    keyword: "Self-Exclusion",
    description: "For players facing challenges in managing their gaming habits, 101 White Label offers seamless self-exclusion options. Players can request temporary or permanent account suspension directly through the online casino operator, ensuring swift and effective access restrictions. Through our API integration, operators can block player access for a designated period, providing an extra layer of protection. During self-exclusion, players will not receive marketing communications, and any remaining funds can either stay in their account or be manually withdrawn upon request."
  },
  {
    keyword: "Play Limits",
    description: "Our API functionality allows operators to set comprehensive play limits that apply across 101 White Label and third-party products. These include: Loss and bet limits per session, day, week, or month. Session length restrictions. Bet limits for specific games. Maximum single bet per game. These features give players greater control over their gaming behavior and support responsible gambling practices."
  },
  {
    keyword: "Reality Checks",
    description: "The Reality Check feature provides periodic in-game notifications to inform players about the duration of their gameplay and their wins and losses. The feature temporarily pauses the game until the player acknowledges the notification, encouraging mindfulness and promoting healthy gaming habits."
  },
  {
    keyword: "Game Speed Management",
    description: "To enhance safety, 101 White Label's gaming platform can be configured to introduce a minimum delay (typically 3 seconds) between game rounds. This setting disables quick spin functionalities, helping prevent impulsive gameplay."
  },
  {
    keyword: "Visible Clock",
    description: "Our games feature a clear time display, enabling players to keep track of time easily. This subtle yet effective tool helps prevent excessive play and supports a well-balanced gaming experience."
  }
];

const ResponsibleGamingPage = () => {
  const { MOBILE_WIDTH, HEADER_MIN_WIDTH } = useResponsiveQueries();

  return (
    <div className='rg-main-container'>
      <div className='rg-row1-container'>
        <motion.div
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#FFFFFF', height: 115, fontSize: 'clamp(40px, 5.5vw, 96px)' }}>
          RESPONSIBLE GAMING
        </motion.div>
      </div>
      <div className='rg-row2-container'>
        <div className='row1'>
          <motion.div
            variants={fadeIn("left", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            className='row-title' style={{ color: '#0D65D9', fontSize: 'clamp(40px, 5.5vw, 96px)', marginBottom: 10 }}>
            GAME SECURITY, FAIRNESS AND ACCREDITATION?
          </motion.div>
          <motion.div
            variants={fadeIn("right", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            style={{ textAlign: MOBILE_WIDTH ? 'center' : 'justify', fontSize: 'clamp(16px, 1.5vw, 24px)', marginBottom: 'clamp(0px, 3vw, 64px)', maxWidth: MOBILE_WIDTH ? '100%' : '86.66%' }} className='description'>
            At 101 White Label, game security, fairness, and accreditation are at the core of our commitment to promoting Responsible Gaming. We prioritize building a safe and transparent gaming environment through robust security measures, ensuring that all data and transactions are fully encrypted and protected against threats. Our platforms integrate advanced security technologies, including SSL encryption, firewall protection, and anti-fraud systems, to safeguard both players and operators.
            Fairness is a critical element in fostering trust. We utilize Random Number Generator (RNG) technology, rigorously tested and certified by independent auditing firms, to guarantee unbiased and unpredictable game outcomes. This approach ensures that every game offers a fair and equitable chance of winning, enhancing player confidence and engagement.
            By upholding high standards in game security, fairness, and accreditation, 101 White Label empowers our partners to build lasting relationships with their players and maintain a reputation of trust and excellence in the iGaming industry.
          </motion.div>
        </div>
        <div className='row2'>
          <motion.img
            variants={fadeIn("down", 0.2)}
            initial="hidden"
            whileInView="show"
            viewport={{ once: false, amount: 0 }}
            style={{
              width: MOBILE_WIDTH ? '100%' : 'calc(100vw - 70%)',
              maxWidth: MOBILE_WIDTH ? 360 : 789,
              margin: HEADER_MIN_WIDTH ? '16px 0px' : '',
              height: 'fit-content', alignSelf: 'center'
            }}
            src={`https://dti2k7ujq2xio.cloudfront.net/images/SlotMachine.webp`}
            alt="Slot Machine"
            loading='lazy'></motion.img>
          <div className='rg-column-container' style={HEADER_MIN_WIDTH ? { width: '100%' } : {}}>
            <motion.div
              variants={fadeIn("left", 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0 }}
              className='description' style={{ textAlign: 'justify', fontSize: 'clamp(16px, 1.5vw, 24px)' }}>
              We want people to enjoy our games for the right reason- to have fun. At <span style={{ fontFamily: 'Proxima Nova Bold' }}>101 Best White-label</span> we take Responsible Gaming seriously and want to offer a source of entertainment that people over the legal age limit can enjoy in a safe, secure and fair environment. Responsible gaming is a driving force to maintain a sustainable business.
            </motion.div>
            <br />
            <motion.div
              variants={fadeIn("left", 0.4)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0 }}
              className='description' style={{ textAlign: 'justify', fontSize: 'clamp(16px, 1.5vw, 24px)' }}>
              As a licensed casino software provider in many jurisdictions, <span style={{ fontFamily: 'Proxima Nova Bold' }}>101 Best White-label</span> ensures that all of our games are developed to the highest standards and are fully compliant in meeting the requirements set out by the regulating authorities. It is our strategy to enter regulated markets and we fully support new regulations which place important responsible gaming criteria on both us as suppliers and operators (the casinos).
            </motion.div>
            <br />
            <motion.div
              variants={fadeIn("left", 0.8)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0 }}
              className='description' style={{ textAlign: 'justify', fontSize: 'clamp(16px, 1.5vw, 24px)' }}>
              <span style={{ fontFamily: 'Proxima Nova Bold' }}>101 Best White-label</span> as a software provider (B2B), has no direct relationship with the players. However we believe it is our responsibility to provide our customers (the operators) all of the tools and support they need when it comes to responsible gaming.
            </motion.div>
          </div>
        </div>
      </div>
      <div className='rg-row3-container'>
        <motion.div
          variants={fadeIn("down", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#FFFFFF', width: '72%', fontSize: 'clamp(40px, 5.5vw, 96px)' }}>
          SELF CONTROL AND SELF-PROTECTION
        </motion.div>
        <ul
          className="description"
          style={{
            fontSize: 'clamp(16px, 1.5vw, 24px)',
            width: "86.66%",
            textAlign: "justify",
            color: "#FFFFFF",
          }}
        >
          {reminderList.map((item, index) => (
            <motion.div
              variants={fadeIn("up", 0.2)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0 }}
              style={{ marginRight: 16 }} key={index}>
              <li>
                <span style={{ fontFamily: 'Proxima Nova Bold' }}>{item.keyword}: </span>
                {item.description}
              </li>
              {index < reminderList.length - 1 && <br />}
            </motion.div>
          ))}
        </ul>
        <motion.div
          variants={fadeIn("left", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          className='row-title' style={{ color: '#FFFFFF', width: '72%', fontSize: 'clamp(40px, 5.5vw, 96px)', margin: '40px 0px 20px' }}>
          Our Commitment to Responsible Gaming
        </motion.div>
        <motion.div
          variants={fadeIn("right", 0.2)}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0 }}
          style={{ textAlign: MOBILE_WIDTH ? 'center' : 'justify', fontSize: 'clamp(16px, 1.5vw, 24px)', marginBottom: 'clamp(0px, 3vw, 64px)', maxWidth: MOBILE_WIDTH ? '100%' : '86.66%', padding: '0 16px', color: '#fff' }} className='description'>
          By implementing these advanced player protection tools, 101 White Label demonstrates a strong commitment to responsible gaming and ensures that online casino operators can offer a safe, fair, and transparent gaming environment. Our focus on compliance, innovation, and player well-being reinforces our position as a trusted leader in the iGaming industry, promoting a sustainable and responsible gaming ecosystem.
        </motion.div>
      </div>
    </div>
  );
};

export default ResponsibleGamingPage;